import React, { ReactNode } from 'react';
import { Grid } from '@mui/material';
import { COLORS_LIGHTGRAY } from '../../../App.constants';

interface IProps {
  borderBottom?: string;
  children: ReactNode;
  isHeader?: boolean;
  marginBottom?: number;
  paddingX?: number;
  paddingY?: number;
}

export const CustomGridRow: React.FC<IProps> = (props) => {
  const { paddingX = 2, paddingY = 1, marginBottom = 1 } = props;

  return (
    <Grid
      container={true}
      item={true}
      alignItems={'center'}
      paddingX={paddingX}
      marginBottom={marginBottom}
      paddingY={paddingY}
      borderBottom={props.borderBottom}
      bgcolor={props.isHeader ? COLORS_LIGHTGRAY : undefined}
    >
      {props.children}
    </Grid>
  );
};

CustomGridRow.displayName = 'CustomGridRow';
